export default __webpack_public_path__ + "static/media/Sora-Regular.9d1a5a24.ttf";